import Box from '@mui/material/Box';
import { ApCircularProgress } from '@uipath/portal-shell-react';
import React from 'react';

export const UiCircularProgress: React.FC = () => (
    <Box sx={{ margin: 'auto' }}>
        <ApCircularProgress />
    </Box>
);
